angular.module('hal-common').controller('HALIndexController', [
  '$scope',
  'UserService',
  'toaster',
  'HALResource',
  '$state',
  '$stateParams',
  function ($scope, UserService, toaster, HALResource, $state, $stateParams) {
    $scope.state = 'generator';
    $scope.app = false;
    $scope.character = false;

    $scope.playerService = {
      addToHistory: function () {},
      assetStatus: [],
      hasAccess: function () {
        return true;
      },
      selectCharacter: function (character) {
        return $scope.selectCharacter(character);
      },
      currentFacts: $scope.facts,
      mode: 'editor',
    };

    $scope.selectCharacter = function () {
      $scope.character.selected = true;
    };

    if (!UserService.user && UserService.halApp) {
      $scope.app = true;
      $scope.state = 'home';
      $scope.fact = { name: $stateParams.word, characterName: '' };
    } else {
      $scope.fact = {
        name: 'Sphingomyelinase',
      };
    }

    $scope.enterGenerator = function () {
      $state.go('hal.generator', { word: $scope.fact.name });
    };

    $scope.exitGenerator = function (mnemonic) {
      if ($scope.app) {
        $scope.state = 'loading';
        $scope.mnemonic = mnemonic;
        $state.go('hal.mnemonic', { id: mnemonic.id, tooltip: 1 });
      }
    };
  },
]);
